// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-eval-debug {
  position: fixed;
  left: max(8px, env(safe-area-inset-left, 0px));
  right: auto;
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  z-index: 1200;
  width: min(280px, calc(100vw - 16px));
  max-width: 280px;
  margin: 0;
  font-size: 0.72rem;
  line-height: 1.35;
  pointer-events: none;
}

.lt-eval-debug--open {
  pointer-events: auto;
}

.lt-eval-debug__toggle {
  pointer-events: auto;
  width: auto;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-height: 34px;
  padding: 6px 12px;
  border: 1px solid rgba(15, 23, 42, 0.18);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.82);
  color: #f8fafc;
  font-size: 0.72rem;
  font-weight: 650;
  cursor: pointer;
  backdrop-filter: blur(8px);
}

.lt-eval-debug__pill {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lt-eval-debug__pill--recording {
  background: #dc2626;
  color: #fff;
}

.lt-eval-debug__pill--uploading {
  background: #d97706;
  color: #fff;
}

.lt-eval-debug__pill--uploaded {
  background: #16a34a;
  color: #fff;
}

.lt-eval-debug__pill--error {
  background: #7f1d1d;
  color: #fff;
}

.lt-eval-debug__pill--idle {
  background: rgba(255, 255, 255, 0.14);
  color: #e2e8f0;
}

.lt-eval-debug__body {
  margin-top: 6px;
  max-height: min(42vh, 280px);
  overflow: auto;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.2);
  background: rgba(15, 23, 42, 0.94);
  color: #e2e8f0;
  padding: 8px 10px;
  backdrop-filter: blur(10px);
}

.lt-eval-debug__state {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-eval-debug__row {
  display: grid;
  grid-template-columns: minmax(0, 42%) minmax(0, 1fr);
  gap: 6px;
  padding: 2px 0;
}

.lt-eval-debug__key {
  opacity: 0.72;
  word-break: break-word;
}

.lt-eval-debug__val {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  word-break: break-all;
}

.lt-eval-debug__log-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  font-weight: 650;
}

.lt-eval-debug__clear {
  border: 0;
  background: transparent;
  color: #93c5fd;
  font-size: 0.68rem;
  cursor: pointer;
  padding: 2px 4px;
}

.lt-eval-debug__log {
  margin: 0;
  padding-left: 1.1rem;
}

.lt-eval-debug__log li {
  margin-bottom: 4px;
}

.lt-eval-debug__log code {
  display: block;
  margin-top: 2px;
  white-space: pre-wrap;
  word-break: break-all;
  opacity: 0.9;
}

.lt-eval-debug__log-empty {
  list-style: none;
  margin-left: -1.1rem;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingEvalDebugPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,oDAAoD;EACpD,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".lt-eval-debug {\n  position: fixed;\n  left: max(8px, env(safe-area-inset-left, 0px));\n  right: auto;\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  z-index: 1200;\n  width: min(280px, calc(100vw - 16px));\n  max-width: 280px;\n  margin: 0;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  pointer-events: none;\n}\n\n.lt-eval-debug--open {\n  pointer-events: auto;\n}\n\n.lt-eval-debug__toggle {\n  pointer-events: auto;\n  width: auto;\n  max-width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  min-height: 34px;\n  padding: 6px 12px;\n  border: 1px solid rgba(15, 23, 42, 0.18);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.82);\n  color: #f8fafc;\n  font-size: 0.72rem;\n  font-weight: 650;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n}\n\n.lt-eval-debug__pill {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.lt-eval-debug__pill--recording {\n  background: #dc2626;\n  color: #fff;\n}\n\n.lt-eval-debug__pill--uploading {\n  background: #d97706;\n  color: #fff;\n}\n\n.lt-eval-debug__pill--uploaded {\n  background: #16a34a;\n  color: #fff;\n}\n\n.lt-eval-debug__pill--error {\n  background: #7f1d1d;\n  color: #fff;\n}\n\n.lt-eval-debug__pill--idle {\n  background: rgba(255, 255, 255, 0.14);\n  color: #e2e8f0;\n}\n\n.lt-eval-debug__body {\n  margin-top: 6px;\n  max-height: min(42vh, 280px);\n  overflow: auto;\n  border-radius: 12px;\n  border: 1px solid rgba(15, 23, 42, 0.2);\n  background: rgba(15, 23, 42, 0.94);\n  color: #e2e8f0;\n  padding: 8px 10px;\n  backdrop-filter: blur(10px);\n}\n\n.lt-eval-debug__state {\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-eval-debug__row {\n  display: grid;\n  grid-template-columns: minmax(0, 42%) minmax(0, 1fr);\n  gap: 6px;\n  padding: 2px 0;\n}\n\n.lt-eval-debug__key {\n  opacity: 0.72;\n  word-break: break-word;\n}\n\n.lt-eval-debug__val {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  word-break: break-all;\n}\n\n.lt-eval-debug__log-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  font-weight: 650;\n}\n\n.lt-eval-debug__clear {\n  border: 0;\n  background: transparent;\n  color: #93c5fd;\n  font-size: 0.68rem;\n  cursor: pointer;\n  padding: 2px 4px;\n}\n\n.lt-eval-debug__log {\n  margin: 0;\n  padding-left: 1.1rem;\n}\n\n.lt-eval-debug__log li {\n  margin-bottom: 4px;\n}\n\n.lt-eval-debug__log code {\n  display: block;\n  margin-top: 2px;\n  white-space: pre-wrap;\n  word-break: break-all;\n  opacity: 0.9;\n}\n\n.lt-eval-debug__log-empty {\n  list-style: none;\n  margin-left: -1.1rem;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
